import React, { useEffect, useState } from "react";
import axios from "axios";
import jwtDecode from "jwt-decode";
import Fade from "react-reveal/Fade";
import ProgressBar from "../components/ProgressBar";
import ErrorIcon from "../assets/warning.svg";
import PDFIcon from "../assets/pdf-svg.svg";
import { useLocation } from "react-router-dom";
import SuccessIcon from "../assets/check.svg";
import OTPPage from "../components/otp";
import "../styles/stepper.css";
import Loader from "../components/loading";
import { Decrypt } from "./helper";

import { useParams } from "react-router-dom";

const BvnForm = ({ setForm, formData, navigation, loading }) => {
  const { previous, go } = navigation;
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [error, setError] = useState("");
  const [idError, setIdError] = useState({});
  const { bvn, customerId } = formData;
  const { next } = navigation;
  const [validationError, setValidationErrors] = useState({});
  const [showOTP, setShowOTP] = useState(false);
  const [updateInfo, setUpdateInfo] = useState(false);
  const [OTPError, setOTPError] = useState("");
  const [OTPSubmitting, setOTPSubmitting] = useState(false);
  const [OTPSubmittingResnd, setOTPSubmittingResnd] = useState(false);
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");

  const { id } = useParams();

  const API_URL = process.env.REACT_APP_BaseApi_URL;



  const validate = async () => {
    setSubmitting(true);

    let merchantDetails = null;
    // merchantName
    //rmCode

    try {
      let decryptPath = await Decrypt(location?.pathname.split("/")[1]);
      merchantDetails = JSON.parse(decryptPath);
    } catch (er) {
      setError(
        "The path you've entered is incorrect. Please check and update the path, then try again"
      );
      setSubmitting(false);
      return;
    }

    const body = {  bvn, merchantDetails };

    try {
      const response = await axios.post(API_URL + "/validate_bvn", body,
           {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_TOKEN}`,
          },
        }
      );
      if (response?.data?.result?.ResponseCode == "00") {
         const accessToken=await jwtDecode(response?.data?.result?.accessToken)
        
        let data=null;
       const decryptedData =await Decrypt(accessToken?.data);
        try {
          data = JSON.parse(decryptedData);
        } catch (error) {
          data = decryptedData;
          console.error("Decryption failed:", error);   
        }
         try {
          data = JSON.parse(data);
        } catch (error) {
          data = data;
          console.error("Decryption failed:", error);   
        }
        sessionStorage.setItem(
          "accessToken",
          response?.data?.result?.accessToken
        );
        // var name = data.FirstName + " " + data.LastName;
        setPhone(data.Phone);
        setEmail(data.Email);
        sessionStorage.setItem("email", data.Email);
        // sessionStorage.setItem("name", name);
        // sendOTP(bvn);
        setShowOTP(true);
        setSubmitting(false);
        setIsValid(true);
        const reference = `${bvn}${Date.now()}`;
        sessionStorage.setItem("reference", reference);
        setError("");
        setValidationErrors({});
        // sessionStorage.setItem(
        //   "res",
        //   JSON.stringify({ ...data, merchantDetails })
        // );
      } else if (
        response?.data?.result?.ResponseCode == "01" ||
        response?.data?.result?.ResponseCode == "09"
      ) {
        setError(response.data?.result?.message || "You have entered an invalid BVN. Please check and try again.");
      } else {
        setError(
          response.data?.result?.message ||
            "You have entered an invalid BVN. Please check and try again."
        );
      }
    } catch (error) {
      setError(error?.response?.data?.message);
      setValidationErrors({});
      setValidationErrors(error?.response?.data);
    } finally {
      setSubmitting(false);
    }
  };

  const sendOTP = async (bvn) => {
    try {
      const response = await axios.post(
        API_URL + "/account/otp/sendToken",
        // "https://providusonline.providusbank.com:8443/api/account/otp/sendToken",
        {
          bvn,
        }
      );

      let OTPDetails = response.data;

      sessionStorage.setItem("accountOpeningUserCode", OTPDetails.userCode);

      return response.data;
    } catch (er) {
      return null;
    }
  };

  const verifyToken = async (token) => {
    if (token === null || token == "") {
      setOTPError("Token is empty");
      return;
    }

    setOTPSubmitting(true);
    // loading(true)
    const data = {
      token,
      usercode: sessionStorage.getItem("accountOpeningUserCode"),
      name: sessionStorage.getItem("email"),
      email: sessionStorage.getItem("name"),
      bvn: bvn,
    };

    try {
      let merchantDetails = null;
      const accessToken = sessionStorage.getItem("accessToken");

      if (!accessToken) {
        throw new Error("No access token found in sessionStorage");
      }
        try {
      let decryptPath = await Decrypt(location?.pathname.split("/")[1]);
      merchantDetails = JSON.parse(decryptPath);
    } catch (er) {
      setError(
        "The path you've entered is incorrect. Please check and update the path, then try again"
      );
      setSubmitting(false);
      return;
    }
      const response = await axios.post(
        API_URL + "/verifyToken",
        {
          token,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      let resp = response.data;

        const encrypedToken=await jwtDecode(resp?.result?.accessToken)
        
        let data=null;
       const decryptedData =await Decrypt(encrypedToken?.data);
        try {
          data = JSON.parse(decryptedData);
        } catch (error) {
          data = decryptedData;
          console.error("Decryption failed:", error);   
        }
          try {
          data = JSON.parse(data);
        } catch (error) {
          data = data;
          console.error("Decryption failed:", error);   
        }

      sessionStorage.setItem(
        "verifyTokenAccessToken",
        resp?.result?.accessToken
      );
      // console.log(resp.customerId)
      var name = data?.FirstName + " " + data?.LastName;
      sessionStorage.setItem("name", name);
       sessionStorage.setItem(
          "res",
          JSON.stringify({ ...data, merchantDetails })
        );
      sessionStorage.setItem("customerId", data?.customerId);
      sessionStorage.setItem("link", data?.link);
      if (data.ResponseCode == "00") {
        setShowOTP(false);
        if (updateInfo) {
          // console.log("go(updateInfo);");
          go("updateInfo");
        } else {
          next();
        }

        // if(bottomRef.current!=null){

        //}
      } else {
        setOTPError(resp.message && "OTP verification failed, kindly retry.");
      }
    } catch (er) {
      setOTPError("OTP verification failed, kindly retry.");
    }
    setOTPSubmitting(false);
    // loading(false)
    // return response.data;
  };

  const reSendOTP = async () => {
    setOTPSubmittingResnd(true);
    // await sendOTP(bvn);
    await validate();
    setOTPSubmittingResnd(false);
  };

  return (
    <div>
      {showOTP ? (
        <OTPPage
          reSendOTP={reSendOTP}
          verifyToken={verifyToken}
          error={OTPError}
          phone={phone}
          email={email}
          submitting={OTPSubmitting}
          setSubmitting={setSubmitting}
          submittingResend={OTPSubmittingResnd}
        />
      ) : (
        <>
          {/* <ProgressBar page="bvn" /> */}

          <Fade bottom>
            <form id="msform">
              <fieldset>
                <div className="form-group">
                  <div className="header">
                    <p
                      style={{
                        fontSize: "1.5rem",
                        color: "blue",
                      }}
                    >
                      Minimum Requirements
                    </p>
                    <ol>
                      <li className="text-xl text-red-400">
                        Specimen Signature
                      </li>
                      <li>Passport photo</li>
                      <li>Utility Bill (not later than 3 months)</li>
                      <li>
                        Valid Identification (NIN, Voters card, International
                        Passport, Drivers License)
                      </li>
                      {/* <li>Amount required for account to be operational is N100,000 and above</li> */}
                    </ol>
                  </div>
                  <label htmlFor="BVN_Input">
                    First, let's validate your BVN
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="BVN_Input"
                    name="bvn"
                    value={bvn
                      .replace(/[^0-9]/g, "")
                      .replace(/(\..*)\./g, "$1")}
                    maxLength="11"
                    onChange={setForm}
                    placeholder="Bank Verification Number"
                  />
                </div>

                <div className="d-flex justify-content-between">
                  {/* {bvn.length === 11 ? (
                <input
                  type="button"
                  name="next"
                  className="btn next action-button"
                  value="Validate"
                  onClick={validate}
                />
              ) : (
                <input
                  type="button"
                  name="next"
                  className="btn next action-button"
                  value="Validate"
                  onClick={validate}
                  disabled
                />
              )} */}
                  {submitting ? (
                    <input
                      type="button"
                      name="next"
                      className="btn next action-button"
                      value="Validating..."
                      disabled
                    />
                  ) : (
                    <input
                      type="button"
                      name="next"
                      className="btn next action-button"
                      value="Validate"
                      onClick={validate}
                      // onClick={()=>go("success")}
                      // onClick={go("updateInfo")}
                    />
                  )}

                  {/* {isValid && (
                <input
                  type="button"
                  name="next"
                  className="next action-button"
                  value="Next"
                  onClick={next}
                />
              )} */}
                </div>
                {isValid && (
                  <div className="d-flex align-items-center">
                    <p className="text-success align-self-center">
                      <img
                        className="mr-2"
                        src={SuccessIcon}
                        alt="error"
                        width="25"
                      />
                      BVN validated successfully!
                    </p>
                  </div>
                )}
                {!isValid && (
                  <div className="d-flex align-center">
                    <p className="text-danger">{error}</p>
                  </div>
                )}
                {validationError?.BVN && (
                  <div className="d-flex align-items-center">
                    <p className="text-danger align-self-center">
                      <img
                        className="mr-2"
                        src={ErrorIcon}
                        alt="error"
                        width="25"
                      />
                      {validationError?.BVN}
                    </p>
                  </div>
                )}
                <label>
                  <b>
                    {" "}
                    <a
                      href="https://oap.providusbank.com/providus_files/reference-form.pdf"
                      target="_blank"
                      style={{ textDecoration: "none", color: "#efb331" }}
                    >
                      {" "}
                      Download Reference{" "}
                      <img
                        className="mr-2"
                        src={PDFIcon}
                        alt="reference"
                        width="25"
                      />
                    </a>
                  </b>
                </label>
              </fieldset>
            </form>
          </Fade>
        </>
      )}
      {OTPSubmitting ? <Loader /> : null}
    </div>
  );
};

export default BvnForm;
